import {
  LuLayoutDashboard,
  LuUsers,
  LuTags,
  LuUtensils,
  LuCalendarCheck,
  LuWallet,
  LuPackage,
  LuShoppingCart,
  LuReceipt,
  LuFileText,
  LuHistory,
  LuChartColumn,
  LuWrench,
} from "react-icons/lu";

import { t } from "../../i18n";

// Single source for the sidebar, the mobile drawer, the page title and the cards on the home page.
// `description` is the one-line summary shown on the home page (the home page itself has none).
export const HOME_ITEM = { path: "/home", label: t("لوحة التحكم"), Icon: LuLayoutDashboard };

export const NAV_ITEMS = [
  HOME_ITEM,
  {
    path: "/dashboard",
    label: t("الموظفون"),
    Icon: LuUsers,
    description: t("إضافة الموظفين وتعديل بياناتهم وأرشفتهم."),
  },
  {
    path: "/work-types",
    label: t("أنواع العمل والأجور"),
    Icon: LuTags,
    description: t("تحديد أنواع العمل والأجر اليومي لكل نوع، ويُستخدم في التسجيل اليومي."),
  },
  {
    path: "/daily",
    label: t("التسجيل اليومي"),
    Icon: LuCalendarCheck,
    description: t("تسجيل أيام العمل اليومية وأجورها لكل موظف."),
  },
  {
    path: "/salaries",
    label: t("تقرير الرواتب"),
    Icon: LuWallet,
    description: t("كشف الرواتب الأسبوعي وتسليم الرواتب وإضافة الإكراميات."),
  },
  {
    path: "/material",
    label: t("قسم المواد"),
    Icon: LuPackage,
    description: t("تسجيل المواد والكميات المسلّمة للموظفين."),
  },
  {
    path: "/purchases",
    label: t("قسم المشتريات"),
    Icon: LuShoppingCart,
    description: t("تسجيل المشتريات وأسعارها ومتابعة إجماليها بكل عملة."),
  },
  {
    path: "/food",
    label: t("الطعام"),
    Icon: LuUtensils,
    description: t("تسجيل أنواع الطعام وأسعارها كل يوم ومتابعة إجمالي كل شهر."),
  },
  {
    path: "/maintenance",
    label: t("الصيانة"),
    Icon: LuWrench,
    description: t(
      "تسجيل صيانة السيارات والمعدات: المشكلة وكيف أُصلحت ومن أصلحها وكم كلّفت ومتى، مع الصيانة المجدولة."
    ),
  },
  {
    path: "/Deduction-section",
    label: t("قسم الاستقطاع"),
    Icon: LuReceipt,
    description: t("تسجيل الاستقطاعات على الموظفين ومتابعتها."),
  },
  {
    path: "/reports",
    label: t("تقارير الموظفين"),
    Icon: LuFileText,
    description: t("تقرير مالي مفصّل لكل موظف مع طباعة وتصدير وكشف راتب."),
  },
  {
    path: "/monthly",
    label: t("التقرير الشهري"),
    Icon: LuChartColumn,
    description: t(
      "مجموع رواتب الشهر وما سُلّم فعلاً والاستقطاعات والسلف والطعام مع مقارنة بالشهر السابق."
    ),
  },
];

// Owners also get the audit log (the server enforces it as well).
export const AUDIT_ITEM = {
  path: "/audit",
  label: t("سجل العمليات"),
  Icon: LuHistory,
  description: t("كل العمليات التي أُجريت في النظام ومن قام بها."),
  ownerOnly: true,
};

export const navItemsFor = (isOwner) => (isOwner ? [...NAV_ITEMS, AUDIT_ITEM] : NAV_ITEMS);

export const PAGE_TITLES = Object.fromEntries(
  [...NAV_ITEMS, AUDIT_ITEM].map((item) => [item.path, item.label])
);
